interface FormErrorProps {
  errors: string[]
}

export default function FormError({ errors }: FormErrorProps) {
  if (!errors.length) return null

  return (
    <div className="rounded-lg bg-red-50 border border-red-200 p-3">
      <ul className="space-y-1">
        {errors.map((err, i) => (
          <li key={i} className="text-sm text-red-700 flex items-start gap-2">
            <svg className="w-4 h-4 shrink-0 mt-0.5 text-red-500" viewBox="0 0 16 16" fill="currentColor">
              <path fillRule="evenodd" d="M8 1a7 7 0 100 14A7 7 0 008 1zM7 5a1 1 0 012 0v4a1 1 0 11-2 0V5zm1 6a1 1 0 100 2 1 1 0 000-2z" clipRule="evenodd" />
            </svg>
            {err}
          </li>
        ))}
      </ul>
    </div>
  )
}
